<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="popup _subscribe" @click="$emit('close')">
        <div class="popupInner" @click.stop>
            <btn-close @click="$emit('close')" />
            <div class="popup__body">
                <h2 class="popup__title">{{ title }}</h2>
                <div class="popup__message">
                    {{ message }}
                </div>
                <button class="btn" @click="openLink()">
                    <span>{{ btn }}</span>
                    <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.6307 9.35321C9.06194 6.55111 13.3501 4.70362 15.4952 3.81074C21.622 1.26375 22.9017 0.821422 23.7246 0.804963C24.0298 0.799031 24.3291 0.888976 24.5805 1.06213C24.7568 1.21422 24.8693 1.42731 24.8952 1.65876C24.9395 1.9466 24.952 2.23845 24.9323 2.52901C24.601 6.02649 23.163 14.4801 22.4326 18.387C22.124 20.0329 21.515 20.5945 20.9246 20.6501C19.6449 20.7673 18.6615 19.8024 17.4271 18.9898C15.485 17.7163 14.3884 16.9325 12.5039 15.6816C10.3251 14.2415 11.7385 13.4576 12.9791 12.1697C13.3042 11.8323 18.9454 6.69719 19.0565 6.23223C19.0711 6.16357 19.0695 6.09243 19.0516 6.02453C19.0337 5.95664 19.0002 5.89389 18.9536 5.84133C18.8861 5.79912 18.8097 5.77324 18.7304 5.76574C18.6511 5.75824 18.5711 5.76933 18.4969 5.79813C18.3035 5.84065 15.2024 7.89044 9.19362 11.9475C8.31307 12.5524 7.51551 12.8473 6.80093 12.8322C6.01297 12.8137 4.49876 12.3857 3.37133 12.0092C1.99086 11.5607 0.902534 11.3241 0.988943 10.5691C1.03969 10.1741 1.58694 9.76879 2.6307 9.35321Z"
                            fill="#00614d"
                        />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import BtnClose from "../UI/BtnClose.vue";
export default {
    components: { BtnClose },
    props: ["title", "subtitle", "message", "img"],
    data() {
        return {
            btn: "Подписаться",
        };
    },
    methods: {
        openLink() {
            window.open("https://t.me/TBTturist_bot?start=link_v1bIywpJzJ", "_blank");
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.popup {
    &._subscribe {
        .btn-close {
            position: absolute;
            top: 15px;
            right: 15px;
        }
        @media (max-width: 768px) {
            .popup__body {
                height: 75vh;
            }
        }
    }
    &__body {
        padding: 60px 30px;
    }
    &__title {
        font-weight: 900;
        font-size: 28px;
        line-height: 36px;
        color: #fff;
        text-align: center;
        white-space: pre-line;
    }
    &__message {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #ecf4ef;
        text-align: center;
        white-space: pre-line;
    }
    .btn {
        background: #fff;
        color: #00614d;
        max-width: 224px;
        margin-top: 20px;
        svg {
            margin-left: 8px;
        }
    }
    .popupInner {
        height: 672px;
        background-image: url("@/assets/img/subscribe.png");
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 25px;
        overflow: hidden;
    }
}
</style>
